import Box from '@mui/material/Box';
import { useMemo } from 'react';
import NRReactGrid from '../../../NRReactGrid/NRReactGrid';
import { DateProvider } from '../../../NRReactGridCustomComponents/NRCustomProviders/DateProvider';
import { CONSTANTS } from '../../../../constants/constants';
import { VULNERABILITY_JIRA_TICKETS_LABELS } from './vulnerabilityJiraTickets.constants';
import { NRJiraTicketStatusProvider } from './providers/NRJiraTicketStatusProvider';
import { NRJiraTicketAssigneeProvider } from './providers/NRJiraTicketAssigneeProvider';
import { NRJiraTicketIssueTypeProvider } from './providers/NRJiraTicketIssueTypeProvider';

const COLUMNS = [
  {
    title: { value: VULNERABILITY_JIRA_TICKETS_LABELS.STATUS },
    name: 'status',
    sortDisabled: true,
    hideFilter: true
  },
  {
    title: { value: VULNERABILITY_JIRA_TICKETS_LABELS.ASSIGNEE },
    name: 'assignee',
    sortDisabled: true,
    hideFilter: true
  },
  {
    title: { value: VULNERABILITY_JIRA_TICKETS_LABELS.ISSUE_TYPE },
    name: 'issueType',
    sortDisabled: true,
    hideFilter: true
  },
  {
    title: { value: VULNERABILITY_JIRA_TICKETS_LABELS.UPDATED },
    name: 'updatedAt',
    sortDisabled: true,
    hideFilter: true,
    dateFormat: CONSTANTS.DATE_FORMAT.MONTH_YEAR_SHORT
  }
];

const COLUMN_EXTENSIONS = [
  { columnName: 'status', align: 'left', width: 140 },
  { columnName: 'assignee', align: 'left', width: 170 },
  { columnName: 'issueType', align: 'left', width: 140 },
  { columnName: 'updatedAt', align: 'left' }
];

function NRJiraTicketsTable({ tickets = [] }) {
  const rows = useMemo(() => tickets.map(ticket => ({ ...ticket })), [tickets]);

  return (
    <Box
      sx={{
        borderTop: theme => `1px solid ${theme.palette.divider}`,
        pb: theme => theme.spacing(1),
        '& .MuiPaper-root': {
          backgroundColor: 'transparent'
        }
      }}
    >
      <NRReactGrid
        rows={rows}
        columns={COLUMNS}
        columnExtensions={COLUMN_EXTENSIONS}
        embedded
        showIntegratedSelection={false}
        showSelectAll={false}
        showFilterSelector={false}
        addDefaultSorting={false}
        statesArray={[]}
        renderersArray={[]}
        providersArray={[
          <NRJiraTicketStatusProvider key="nrJiraTicketStatusProvider" for={['status']} />,
          <NRJiraTicketAssigneeProvider key="nrJiraTicketAssigneeProvider" for={['assignee']} />,
          <NRJiraTicketIssueTypeProvider key="nrJiraTicketIssueTypeProvider" for={['issueType']} />,
          <DateProvider key="jiraTicketUpdatedAtProvider" for={['updatedAt']} />
        ]}
        showIntegratedPagination={false}
        allowColumnReOrdering={false}
        elevation={0}
        variant="elevation"
      />
    </Box>
  );
}

export default NRJiraTicketsTable;
